export class ValidationService {
    static isSimpleResponse(query, searchKeywordBlacklist = []) {
        return searchKeywordBlacklist.map(keyword => keyword.toLowerCase()).includes(query.toLowerCase()) ||
            !isNaN(Number(query.replace(/\s/g, '')));
    }

    static shouldSkipSearch(query, searchKeywordBlacklist) {
        return this.isSimpleResponse(query, searchKeywordBlacklist);
    }

    static validateSearchQuery(query) {
        if (!query || typeof query !== 'string') {
            return { isValid: false, error: 'Query must be a non-empty string' };
        }

        if (query.trim().length === 0) {
            return { isValid: false, error: 'Query cannot be empty' };
        }

        return { isValid: true };
    }
}